export class Openfire{

    customerName = '';
    userName = '';

    public static of(o: unknown): Openfire {
        return Object.assign(new Openfire(), o);
    }
}
